import {
  TAnalyticsKey,
  TDealType,
  TOfferCategory,
  TOfferType,
} from '../../repositories/chats/entities/chat_hint/SaveChatHintsByOfferRequestSchema';
import {
  TSaveChatMessagesHintsByOfferResponse,
  fetchSaveChatMessagesHintsByOffer,
} from '../../repositories/chats/v1/save-chat-messages-hints-by-offer';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TOffer } from '../../types/offer';
import { TThunkAction } from '../../types/redux/thunk';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

type TSaveChatMessageHintParams = {
  offer: TOffer;
  analyticsKey: TAnalyticsKey;
  messageText: string;
};

const DEFAULT_ERROR_MESSAGE = 'Не удалось сохранить вопрос-подсказку';

export const saveChatMessageHint =
  ({ offer, analyticsKey, messageText }: TSaveChatMessageHintParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const parameters = {
      analyticsKey,
      dealType: offer.dealType as TDealType,
      messageText,
      offerCategory: offer.category as TOfferCategory,
      offerType: offer.offerType as TOfferType,
    };

    try {
      const { response, statusCode }: TSaveChatMessagesHintsByOfferResponse = await fetchSaveChatMessagesHintsByOffer({
        httpApi,
        parameters,
        config: {
          requestConfig: {
            withCredentials: true,
          },
        },
      });

      if (statusCode !== 200) {
        throw getResponseError({
          domain: EExceptionDomain.Chat,
          response,
          defaultMessage: DEFAULT_ERROR_MESSAGE,
          statusCode,
        });
      }
    } catch (error) {
      const exception = getGenericLikeError({
        error,
        domain: EExceptionDomain.Chat,
        message: DEFAULT_ERROR_MESSAGE,
      });

      logger.error(exception, {
        microserviceName: 'chats',
        pathApi: '/v1/save-chat-messages-hints-by-offer/',
        parameters: JSON.stringify(parameters),
      });
    }
  };
